import request from '@/utils/request'

export function login(data) {//登录
  return request({
    url: '/api/login/index',
    method: 'post',
    loading: true,
    data
  })
}
export function register(data) {//注册
  return request({
    url: '/api/login/register',
    method: 'post',
    loading: true,
    data
  })
}
export function sendEmail(data) {//发送邮箱验证码
  return request({
    url: '/api/login/sendEmail',
    method: 'post',
    loading: true,
    data
  })
}
export function forget(data) {//忘记密码重置
  return request({
    url: '/api/login/forget',
    method: 'post',
    loading: true,
    data
  })
}
export function userInfo(data) {//用户信息
  return request({
    url: '/api/users/info',
    method: 'post',
    data
  })
}
export function setBirth(data) {//设置生日 
  return request({
    url: '/api/users/setbirth',
    method: 'post',
    loading: true,
    data
  })
}
export function getGameList(data) {//游戏列表
  return request({
    url: '/api/index/gamelist',
    method: 'post',
    data
  })
}
export function getGameCont(data) {//游戏详情
  return request({
    url: '/api/game/getcont',
    method: 'post',
    data
  })
}

// 获取游戏URL
export function getgameurl(data) {
  return request({
    url: '/api/game/getgameurl',
    method: 'post',
    loading: true,
    data
  })
}
export function getIndexHome(data) {
  return request({
    url: '/api/index/home',
    method: 'post',
    data
  })
}
export function checkDUser(data) {//提交本地设备编码
  return request({
    url: '/api/index/checkDUser',
    method: 'post',
    data
  })
}
export function noticedetial(data) {//公告详情
  return request({
    url: '/api/index/noticedetial',
    method: 'post',
    data
  })
}
export function getrechinfo(data) {//获取充值方式
  return request({
    url: '/api/account/getrechinfo',
    method: 'post',
    data
  })
}
export function accountlist(data) {//资金记录
  return request({
    url: '/api/account/list', 
    method: 'post',
    data
  })
}
export function accountCancelrech(data) {//取消充值
  return request({
    url: '/api/account/cancelrech',
    method: 'post',
    loading: true,
    data
  })
}
export function uploadUpimg(data) {//上传图片
  return request({
    url: '/api/upload/upimg',
    method: 'post',
    headers: { 'Content-Type': 'multipart/form-data' },
    code:true,
    loading: true,
    data
  })
}
export function accountRechupimg(data) {//提交充值截图
  return request({
    url: '/api/account/rechupimg',
    method: 'post',
    loading: true,
    data
  })
}
export function accountRechlog(data) {//充值记录 page 页数 day 天数
  return request({
    url: '/api/account/rechlog',
    method: 'post',
    loading: true,
    data
  })
}
export function ordersRetlog(data) {//下注记录
  return request({
    url: '/api/orders/betlog',
    method: 'post',
    loading: true,
    data
  })
}
export function accountAddrech(data) {//添加充值
  return request({
    url: '/api/account/addrech',
    method: 'post',
    loading: true,
    data
  })
}
export function ranklist(data) {//viplist
  return request({
    url: '/api/users/ranklist',
    method: 'post',
    data
  })
}
export function gamehistory(data) {//游戏记录
  return request({
    url: '/api/users/gamehistory',
    method: 'post',
    loading: true,
    data
  })
}
export function userhaslogin(data) {//是否登录
  return request({
    url: '/api/index/userhaslogin',
    method: 'post',
    data
  })
}
export function gamesearch(data) {//搜索游戏
  return request({
    url: '/api/index/gamesearch',
    method: 'post',
    data
  })
}
export function getconfig(data) {//玩法规则
  return request({
    url: '/api/index/getconfig',
    method: 'post',
    data
  })
}
export function getnoticelist(data) {//公告列表
  return request({
    url: '/api/index/getnoticelist',
    method: 'post',
    data
  })
}
export function myteam(data) {//邀请团队
  return request({
    url: '/api/users/myteam',
    method: 'post',
    data
  })
}
export function upimg(data) {//上传头像
  return request({
    url: '/api/upload/upimg',
    method: 'post',
    code:true,
    data
  })
}
export function edituser(data) {//保存用户信息
  return request({
    url: '/api/users/edituser',
    method: 'post',
    data
  })
}
export function editHeaderImg(data) {//修改头像
  return request({
    url: '/api/users/editHeaderImg',
    method: 'post',
    loading: true,
    data
  })
}
export function changepassword(data) {//修改密码
  return request({
    url: '/api/users/changepassword',
    method: 'post',
    loading: true,
    data
  })
}
export function invitTask(data) {//邀请任务
  return request({
    url: '/api/team/invite_task',
    method: 'post',
    data
  })
}
export function getInviteReward(data) {//领取邀请奖励
  return request({
    url: '/api/team/get_invite_reward',
    method: 'post',
    data
  })
}
export function mycommissionLog(data) {//佣金领取记录
  return request({
    url: '/api/team/mycommissionLog',
    method: 'post',
    loading: true,
    data
  })
}
export function myrewardLog(data) {//Running Bonus记录
  return request({
    url: '/api/team/myrewardLog',
    method: 'post',
    loading: true,
    data
  })
}
export function cashlog(data) {//提现记录 page 页数 day 天数
  return request({
    url: '/api/account/cashlog',
    method: 'post',
    loading: true,
    data
  })
}

export function getwinnerlist(data) {//winners
  return request({
    url: '/api/index/getwinnerlist',
    method: 'post',
    data
  })
}
export function messagelist(data) {//邮件列表
  return request({
    url: '/api/users/messagelist',
    method: 'post',
    loading: true,
    data
  })
}
export function getmssagedetail(data) {//邮件详情
  return request({
    url: '/api/users/getmssagedetail',
    method: 'post',
    loading: true,
    data
  })
}
export function setAllMssageRead(data) {//批量设置已读
  return request({
    url: '/api/users/setAllMssageRead',
    method: 'post',
    loading: true,
    data
  })
}
export function delMssageRead(data) {//批量删除消息
  return request({
    url: '/api/users/delMssageRead',
    method: 'post',
    loading: true,
    data
  })
}
export function changerank(data) {//邮件详情
  return request({
    url: '/api/users/changerank',
    method: 'post',
    data
  })
}
export function ranklog(data) {//VIP记录
  return request({
    url: '/api/users/ranklog',
    method: 'post',
    data
  })
}
export function gamecatelist(data) {//游戏分类列表
  return request({
    url: '/api/index/gamecatelist',
    method: 'post',
    data
  })
}
export function getnewlist(data) {//游戏列表
  return request({
    url: '/api/index/getnewlist',
    method: 'post',
    data
  })
}
export function getusercashinfo(data) {//获取用户提现信息
  return request({
    url: '/api/users/getusercashinfo',
    method: 'post',
    loading: true,
    data
  })
}
export function setusercashinfo(data) {//设置用户提现信息
  return request({
    url: '/api/users/setusercashinfo',
    method: 'post',
    loading: true,
    data
  })
}
export function getCashInfo(data) {//添加提现
  return request({
    url: '/api/account/cashinfo',
    method: 'post',
    loading: true,
    data
  })
}
export function addCash(data) {//添加提现
  return request({
    url: '/api/account/addCash',
    method: 'post',
    loading: true,
    data
  })
}
export function teamCenter(data) {//团队中心
  return request({
    url: '/api/team/center',
    method: 'post',
    data
  })
}
export function teamChildList(data) {//团队成员记录（page、pagesize）
  return request({
    url: '/api/team/childlist',
    method: 'post',
    data
  })
}
export function getGameType(data) {//获取游戏类型
  return request({
    url: '/api/game/getGameType',
    method: 'post',
    data
  })
}
export function getCustomer(data) {
  return request({
    url: '/api/index/getCustomer',
    method: 'post',
    data
  })
}
export function getCooperate(data) {
  return request({
    url: '/api/index/getCooperate',
    method: 'post',
    data
  })
}
export function getRtpList(data) {
  return request({
    url: '/api/index/getRtpList',
    method: 'post',
    data
  })
}
export function getRtpCateList(data) {
  return request({
    url: '/api/index/getRtpCateList',
    method: 'post',
    data
  })
}
export function setFeedback(data) {//设置反馈
  return request({
    url: '/api/users/setFeedback',
    method: 'post',
    loading: true,
    data
  })
}
export function getplatType(data) {
  return request({
    url: '/api/users/getplatType',
    method: 'post',
    data
  })
}
